import type { GetAntiForgeryResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getAntiForgery = async (lang?: string) => {
    return await getGenericEndpoint<GetAntiForgeryResponse>('errors/anti-forgery', lang);
};
